import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoodJob = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 329.899,
			y1: 78.5615,
			x2: 394.899,
			y2: 63.5615,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 315.827,
			y1: 78.4156,
			x2: 262.827,
			y2: 56.4156,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 54C398.582 54 395 57.5817 395 62C395 66.4183 398.582 70 403 70C407.418 70 411 66.4183 411 62C411 57.5817 407.418 54 403 54Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M403 59C401.343 59 400 60.3431 400 62C400 63.6569 401.343 65 403 65C404.657 65 406 63.6569 406 62C406 60.3431 404.657 59 403 59Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322 72.999C317.582 72.999 314 76.5807 314 80.999C314 85.4173 317.582 88.999 322 88.999C326.418 88.999 330 85.4173 330 80.999C330 76.5807 326.418 72.999 322 72.999Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M322 77.999C320.343 77.999 319 79.3422 319 80.999C319 82.6559 320.343 83.999 322 83.999C323.657 83.999 325 82.6559 325 80.999C325 79.3422 323.657 77.999 322 77.999Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(0.920735 0.390189 0.390189 -0.920735 127.568 32)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(-0.991998 -0.126254 -0.126254 0.991998 72 98)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(-0.484316 0.874893 0.874893 0.484316 115 35)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 106C75.5817 106 72 102.418 72 98C72 93.5817 75.5817 90 80 90C84.4183 90 88 93.5817 88 98C88 102.418 84.4183 106 80 106Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 101C78.3431 101 77 99.6569 77 98C77 96.3431 78.3431 95 80 95C81.6569 95 83 96.3431 83 98C83 99.6569 81.6569 101 80 101Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 98C4.58172 98 1 94.4183 1 90C1 85.5817 4.58172 82 9 82C13.4183 82 17 85.5817 17 90C17 94.4183 13.4183 98 9 98Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 93C7.34315 93 6 91.6569 6 90C6 88.3431 7.34315 87 9 87C10.6569 87 12 88.3431 12 90C12 91.6569 10.6569 93 9 93Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 37C115.582 37 112 33.4183 112 29C112 24.5817 115.582 21 120 21C124.418 21 128 24.5817 128 29C128 33.4183 124.418 37 120 37Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M120 32C118.343 32 117 30.6569 117 29C117 27.3431 118.343 26 120 26C121.657 26 123 27.3431 123 29C123 30.6569 121.657 32 120 32Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M119.3 117.65C119.3 119.67 117.67 121.3 115.65 121.3C113.63 121.3 112 119.67 112 117.65C112 115.63 113.63 114 115.65 114C117.67 114 119.3 115.63 119.3 117.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.043 121.173C340.833 121.183 340.623 121.133 340.433 121.003C339.983 120.693 339.863 120.083 340.173 119.633L345.933 111.193C346.103 110.943 346.383 110.783 346.683 110.763C346.963 110.733 347.283 110.863 347.483 111.083L351.203 115.173L357.873 104.133C358.033 103.873 358.293 103.703 358.593 103.663C358.893 103.633 359.193 103.733 359.413 103.943L363.463 107.973L372.013 95.4326C372.323 94.9826 372.933 94.8626 373.383 95.1726C373.833 95.4826 373.953 96.0926 373.643 96.5426L364.433 110.063C364.273 110.303 364.003 110.463 363.713 110.493C363.403 110.533 363.133 110.413 362.923 110.213L358.923 106.233L352.223 117.333C352.063 117.603 351.783 117.773 351.473 117.803C351.143 117.843 350.853 117.713 350.643 117.483L346.873 113.343L341.823 120.753C341.643 121.013 341.353 121.163 341.063 121.183L341.043 121.173Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0426 36.01C39.8326 36 39.6226 36.0499 39.4326 36.1799C38.9826 36.4899 38.8626 37.1 39.1726 37.55L44.9326 45.99C45.1026 46.24 45.3826 46.4001 45.6826 46.4201C45.9626 46.4501 46.2826 46.32 46.4826 46.1L50.2026 42.01L56.8726 53.0501C57.0326 53.3101 57.2926 53.48 57.5926 53.52C57.8926 53.55 58.1926 53.45 58.4126 53.24L62.4626 49.21L63.5 48.1826C63.6284 47.9243 63.5926 47.36 63.4326 47.12C63.2726 46.88 63.0026 46.7199 62.7126 46.6899C62.4026 46.6499 62.1326 46.77 61.9226 46.97L57.9226 50.95L51.2226 39.85C51.0626 39.58 50.7826 39.41 50.4726 39.38C50.1426 39.34 49.8526 39.47 49.6426 39.7L45.8726 43.84L40.8226 36.4299C40.6426 36.1699 40.3526 36.02 40.0626 36L40.0426 36.01Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 206,
			cy: 70,
			r: 70,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144 79C149.143 114.216 181.379 138.523 216 133.292",
			stroke: "#002E5F",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4019_39550",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 136,
			y: 0,
			width: 140,
			height: 140,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 206,
				cy: 70,
				r: 70,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4019_39550)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M209.143 110.057C197.578 107.315 173.208 93.7226 170.112 88.9828L170.107 88.967C167.732 85.3067 169.39 81.5106 170.274 79.9559C170.451 79.6627 170.594 79.451 170.675 79.334C170.627 79.2685 170.598 79.1908 170.59 79.1094C170.359 78.9286 169.9 78.5421 169.378 77.9469C168.25 76.6531 166.845 74.3934 166.846 71.0728C166.834 67.4561 168.108 65.6453 168.981 64.8362C169.037 64.7844 169.092 64.7367 169.144 64.6927C169.152 64.6529 169.165 64.6135 169.183 64.5754C169.273 64.3937 169.468 64.2991 169.659 64.3298C169.743 64.2815 169.791 64.2602 169.791 64.2602C169.791 64.2602 169.546 63.9021 169.309 63.2585C168.847 62.0558 168.384 59.8114 169.423 56.844C170.462 53.8766 173.301 52.8756 175.181 52.5363C175.617 52.4563 176.001 52.4138 176.296 52.3913C176.203 52.2608 176.183 52.0848 176.259 51.931C176.351 51.7446 176.554 51.6499 176.749 51.688C176.734 51.6148 176.718 51.5365 176.703 51.4535C176.234 49.0876 175.693 42.8252 182.796 42.3162C191.57 41.6807 208.843 53.572 208.843 53.572C208.843 53.572 207.411 42.5086 208.814 35.108C210.223 27.7232 213.764 24.0108 216.707 26.2769C217.835 27.1485 218.439 30.9456 219.036 35.6583L219.044 35.6624L219.052 35.6666L219.053 35.667L219.053 35.6671C219.276 35.777 219.367 36.0466 219.258 36.2695C219.227 36.3322 219.183 36.3845 219.132 36.4249C219.175 36.7696 219.218 37.1185 219.261 37.4708L219.511 39.4521C220.362 46.3154 221.472 53.8857 224.13 57.0789C224.87 57.9574 225.738 58.9513 226.675 59.9925C231.055 64.829 233.448 70.8836 233.768 77.04C233.775 77.0445 233.782 77.049 233.789 77.0536C235.222 77.9965 236.905 79.1019 238.758 80.2908C240.95 81.6996 243.366 83.2446 245.903 84.8365C247.447 85.7946 249.013 86.7632 250.616 87.7368C250.905 87.9119 251.199 88.0897 251.493 88.2674C251.788 88.4456 252.083 88.6238 252.373 88.7994C257.913 92.1071 263.5 95.24 268.076 97.3745C270.747 98.6162 273.801 99.9772 277.572 101.658C289.413 106.937 308.334 115.371 344.716 133.173L350.182 135.864L285.441 157.888L219.446 112.716L214.217 109.128C212.416 110.05 210.701 110.424 209.143 110.057Z",
					fill: "#D9DEEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.734 78.8304C169.489 83.7761 192.842 99.0486 204.186 102.597C209.666 104.3 217.819 96.6548 224.795 88.2816C233.046 78.3798 233.158 64.0336 225.195 53.889C224.334 52.7846 223.538 51.732 222.861 50.8036C220.434 47.4314 219.86 39.8019 219.493 32.8958C219.457 32.2311 219.42 31.5664 219.383 30.9018C219.094 25.3411 218.82 20.6238 217.623 19.556C214.846 17.0885 211.053 20.5428 209.128 27.8102C207.208 35.0939 207.859 46.2306 207.859 46.2306C207.859 46.2306 191.464 33.1541 182.668 33.1711C175.546 33.1794 175.645 39.4643 175.947 41.8574C176.011 42.4284 176.105 42.7842 176.105 42.7842C176.105 42.7842 175.378 42.7162 174.353 42.8305C172.454 43.0368 169.552 43.8356 168.306 46.7226C167.061 49.6096 167.365 51.881 167.742 53.1133C167.933 53.7719 168.152 54.1464 168.152 54.1464C168.152 54.1464 167.789 54.2766 167.303 54.6639C166.375 55.4096 164.978 57.1265 164.735 60.735C164.501 64.0473 165.743 66.4002 166.778 67.7702C167.467 68.6781 168.056 69.1452 168.056 69.1452C168.056 69.1452 167.845 69.3912 167.53 69.8372C166.539 71.3259 164.618 74.996 166.73 78.8142L166.734 78.8304Z",
					fill: "#E9EBF0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.069 40.2226C191.114 40.5518 187.401 42.3834 188.192 47.0753",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.854 51.3176C183.218 51.5637 180.158 53.2198 181.013 57.8745",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M179.838 62.6605C178.332 63.3474 175.752 65.3858 176.986 70.0723",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M176.274 75.8281C174.466 77.4177 173.698 78.7334 174.552 82.9727",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.505 70.4015L168.353 69.0044",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.174 57.7121L167.911 54.6436",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.121 45.5969L175.858 42.5283",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.702 20.8989C215.346 23.7767 215.614 25.4254 216.828 27.284C217.759 28.7093 219.075 29.4765 219.075 29.4765",
					stroke: "#002E5F",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M343.06 138.256L276.93 155.673L214.275 105.973L209.31 102.024L207.41 100.519L226.069 67.5078C226.069 67.5078 228.011 69.0367 231.09 71.4071C232.454 72.4486 234.055 73.6695 235.819 74.9857C237.907 76.5453 240.208 78.2563 242.627 80.0226C244.1 81.0869 245.594 82.1632 247.125 83.2471C247.677 83.6377 248.25 84.0401 248.802 84.4306C254.096 88.1197 259.449 91.6377 263.864 94.0887C274.532 99.9937 291.596 108.4 337.797 135.188L343.06 138.256Z",
					fill: "#E9EBF0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.288 120.282L248.787 84.4509C246.692 82.9969 244.621 81.502 242.612 80.0428L221.424 111.663L232.288 120.282Z",
					fill: "#002E5F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.5 73.9768L212.9 107.926C212.363 108.708 212.554 109.764 213.324 110.322L221.956 116.313C222.738 116.851 223.794 116.659 224.336 115.894L247.98 81.9846C248.518 81.2032 248.322 80.131 247.557 79.589L238.879 73.5577C238.098 73.02 237.042 73.2116 236.484 73.9811L236.5 73.9768Z",
					fill: "#3085E1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.878 89.8163L220.567 83.0657C222.161 80.7786 224.838 79.5202 227.615 79.7571L235.804 80.4534C238.581 80.6902 241.015 82.3834 242.194 84.8912L245.69 92.3218C246.874 94.8457 246.631 97.7972 245.037 100.084L240.348 106.835C238.755 109.122 236.078 110.38 233.301 110.143L225.112 109.447C222.335 109.21 219.9 107.517 218.721 105.009L215.225 97.5788C214.042 95.0548 214.285 92.1034 215.878 89.8163Z",
					fill: "#3085E1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.525 91.1587L239.808 89.6184C238.4 86.635 235.499 84.6152 232.211 84.3401L230.514 84.1991C227.225 83.924 224.024 85.4242 222.144 88.1326L221.18 89.5277C219.3 92.2361 218.999 95.7561 220.407 98.7396L221.124 100.28C222.532 103.263 225.433 105.283 228.722 105.558L230.419 105.699C233.707 105.974 236.908 104.474 238.789 101.766L239.753 100.371C241.633 97.6622 241.934 94.1422 240.525 91.1587Z",
					fill: "#006ADC"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 38,
			height: 24,
			rx: 8,
			transform: "matrix(-1 0 0 1 292 11)",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266.884 31.7827C267.847 31.1988 267.847 29.8012 266.884 29.2173L256.278 22.7875C255.278 22.1814 254 22.9012 254 24.0702L254 36.9298C254 38.0988 255.278 38.8186 256.278 38.2125L266.884 31.7827Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 284 21)",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 275 21)",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 266 21)",
			fill: "#E9EBF0"
		})
	]
});
const ForwardRef = forwardRef(SvgGoodJob);
export default ForwardRef;
